import React, { useState } from 'react';
import { Tab, TabList } from 'react-tabs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import FormSection from '../form-section/FormSection';
import MessagesList from '../messages-list/MessagesList';
import GenerateMessagesForm from './generate-messages-form/GenerateMessagesForm';
import GeneratedMessage from './generated-message/GeneratedMessage';
import { COMMON_GENIE_SORT } from '../../../hooks/useGenieMessagesSort';
import useLocalSort from '../../../hooks/useLocalSort';
import GenerateFilters from '../generate-filters/GenerateFilters';

import scss from './GenerateMessages.module.scss';

function GenerateMessages({ onGenerateMessages, onReply, onResetSession, onFileUpload, projectType }) {
  const { t } = useTranslation('genie');

  const [isShowForm, setIsShowForm] = useState(true);
  const [sort, setSort] = useState(COMMON_GENIE_SORT);

  const messages = useSelector((state) => state.genie.messages);
  const isFormLoading = useSelector((state) => state.genie.isFormLoading);

  const sortedMessages = useLocalSort({ content: messages, sort: sort });

  const handleChangeForVisibility = () => {
    setIsShowForm((prevState) => !prevState);
  };

  const handleChangeSort = ({ sort, direction, getSortValue }) => {
    setSort({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.sectionWrapper}>
      <TabList className={scss.tabList}>
        <Tab selected>{t('generateNew')}</Tab>
      </TabList>

      <FormSection
        isShowForm={isShowForm}
        onChangeVisibility={handleChangeForVisibility}
        hideLabel={t('generateMessagesForm')}>
        <GenerateMessagesForm
          onGenerateMessages={onGenerateMessages}
          onReply={onReply}
          onResetSession={onResetSession}
          onFileUpload={onFileUpload}
          projectType={projectType}
        />
      </FormSection>

      <GenerateFilters sort={sort} onSort={handleChangeSort} />

      <MessagesList
        content={sortedMessages}
        className={scss.listWrapper}
        renderMessage={(message) => <GeneratedMessage key={`${message.message}-${message.count}`} message={message} />}
        isLoading={isFormLoading}
      />
    </div>
  );
}

export default GenerateMessages;
